const photoContext = require.context(
  "./cod/imgs/travel",
  true,
  /\.(avif|jpe?g|png|webp)$/i
);

const titleFromFilename = (path) => {
  const filename = path.split("/").pop().replace(/\.[^.]+$/, "");
  return filename
    .replace(/[-_]+/g, " ")
    .replace(/\b\w/g, character => character.toUpperCase());
};

const photosByCountryCode = photoContext.keys().reduce((collections, path) => {
  const [, countryCode] = path.match(/^\.\/([^/]+)\//) || [];

  if (!countryCode) return collections;

  const code = countryCode.toUpperCase();
  const importedPhoto = photoContext(path);
  const src = importedPhoto.default || importedPhoto;

  collections[code] = [
    ...(collections[code] || []),
    {
      src,
      alt: titleFromFilename(path),
    },
  ];

  return collections;
}, {});

export const getTravelPhotos = countryCode =>
  photosByCountryCode[countryCode] || [];
